/**
 * @public
 */
export class Cookie {
    static of(name, value) {
        return new Cookie(name, value);
    }
    _name;
    _value;
    constructor(name, value) {
        this._name = name;
        this._value = value;
    }
    get name() {
        return this._name;
    }
    get value() {
        return this._value;
    }
    equals(value) {
        return (value instanceof Cookie &&
            value._name === this._name &&
            value._value === this._value);
    }
    toJSON() {
        return {
            name: this._name,
            value: this._value,
        };
    }
    toString() {
        return `${this._name}=${this._value}`;
    }
}
/**
 * @public
 */
(function (Cookie) {
    function from(json) {
        return Cookie.of(json.name, json.value);
    }
    Cookie.from = from;
    function isCookie(value) {
        return value instanceof Cookie;
    }
    Cookie.isCookie = isCookie;
})(Cookie || (Cookie = {}));
//# sourceMappingURL=cookie.js.map